import Axios from "axios";
const defaultAxios = Axios.create({
  headers: {
    "Content-type": "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0eWR3bmlldWt1YmtkeWFod29pIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTgyMDY4NzgsImV4cCI6MTk3Mzc4Mjg3OH0.kOD2FjiA4niDjjblR0tjdeNT6ctELh7Nrnc-1td3p8w",
    apiKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF0eWR3bmlldWt1YmtkeWFod29pIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTgyMDY4NzgsImV4cCI6MTk3Mzc4Mjg3OH0.kOD2FjiA4niDjjblR0tjdeNT6ctELh7Nrnc-1td3p8w",
    Prefer: "return=representation",
    "content-type": "application/json",
  },
});
defaultAxios.interceptors.response.use(
  (res) => {
    return res.data;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export function apiClient(method, url, options = {}) {
  const { data = {}, headers = {}, params = {}, ...rest } = options;
  return defaultAxios({
    url,
    data,
    method,
    params,
    headers,
    ...rest,
  });
}

export const apis = {
  get: (url, args) => apiClient("get", url, args),
  post: (url, args) => apiClient("post", url, args),
  put: (url, args) => apiClient("put", url, args),
  patch: (url, args) => apiClient("patch", url, args),
  delete: (url, args) => apiClient("delete", url, args),
};
